"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var urls_1 = __importDefault(require("../../app/urls"));
var store_1 = require("../../app/store");
var components_1 = require("../../common/components");
var heightBreak = '@media screen and (min-height: 800px)';
var topPadding = 200;
var topPaddingHeightBreak = 280;
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b;
    return (0, core_1.createStyles)({
        root: (_a = {
                padding: theme.spacing(6, 12)
            },
            _a[theme.breakpoints.down('sm')] = {
                padding: theme.spacing(3, 4.5),
            },
            _a[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(1.5),
            },
            _a),
        content: (_b = {
                width: 500,
                position: 'absolute',
                zIndex: 10,
                top: topPadding,
                left: '50%',
                backgroundImage: 'linear-gradient(to bottom, white 30%, rgba(255,255,255,0))',
                background: theme.palette.common.white,
                transform: 'translate(-50%, 0)',
                border: theme.youwell.borders.dim,
                borderRadius: 24,
                padding: theme.spacing(4),
                boxShadow: theme.shadows[5],
                minHeight: 300,
                maxHeight: "calc(100vh - ".concat(topPadding, "px - 50px)"),
                overflowY: 'auto'
            },
            _b[heightBreak] = {
                maxHeight: "calc(100vh - ".concat(topPaddingHeightBreak, "px - 50px)"),
                top: topPaddingHeightBreak,
            },
            _b[theme.breakpoints.down('xs')] = {
                position: 'relative',
                width: '100%',
                left: 0,
                top: 0,
                transform: 'none',
                border: 0,
                borderRadius: 0,
                padding: theme.spacing(2),
                boxShadow: 'none',
                minHeight: 'auto',
                maxHeight: 'none',
                overflowY: 'inherit',
            },
            _b),
        programs: {
            padding: theme.spacing(4),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
        },
        program: {
            flex: '1 1 auto',
            background: theme.youwell.colors.secondaryBackground,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(4),
            margin: theme.spacing(2),
        },
    });
});
var ProgramSelect = function () {
    var classes = useStyles();
    var programs = (0, store_1.useYouwellSelector)(function (state) { var _a; return (_a = state.pageSettings.appConfig) === null || _a === void 0 ? void 0 : _a.publicPrograms; });
    var singlePublicProgram = (0, store_1.useYouwellSelector)(function (state) { var _a; return (_a = state.pageSettings.appConfig) === null || _a === void 0 ? void 0 : _a.publicProgramId; });
    if (!programs || programs.length === 0) {
        if (singlePublicProgram) {
            return (react_1.default.createElement(react_router_1.Redirect, { to: urls_1.default.outsideProgram.program }));
        }
        return (react_1.default.createElement(react_router_1.Redirect, { to: urls_1.default.home }));
    }
    if (programs.length === 1) {
        return (react_1.default.createElement(react_router_1.Redirect, { to: urls_1.default.outsideProgram.program }));
    }
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement("div", { className: classes.content },
            programs.length < 2 && (react_1.default.createElement(components_1.InfoMessage, { messageKey: "noContent" })),
            react_1.default.createElement("div", { className: classes.programs }, programs.map(function (program) { return (react_1.default.createElement(react_router_dom_1.Link, { key: program.id, className: classes.program, to: "".concat(urls_1.default.outsideProgram.program, "/").concat(program.id) },
                react_1.default.createElement(core_1.Typography, { variant: "button", noWrap: true, align: "center", display: "block" }, program.name))); })))));
};
exports.default = ProgramSelect;
